<!-- Header -->
<div class="sub-header">
  <div class="container" style="height: 100%;">
    <div class="controls-panel">
      <input type="text" name="search" class="form-control" placeholder="Search by Name" 
                      [(ngModel)]="blurbQueryParam.query" style="border-color:#CFD7E6;font-weight:200;"
                      (ngModelChange)="getBlurbsList()">
      <button type="button" class="btn btn-bvq pull-right" style="min-width: fit-content; margin-left: 10px;" [routerLink]="['/manage/research/blurbs/new']">New Blurb</button>
    </div>
  </div>
</div>

<!-- List of Blurbs -->
<div class="container" [hidden]="loading">
  <!-- No blurbs found message -->
  <div class="no-items" *ngIf="blurbsList?.length == 0">
    no blurbs found
  </div>

  <!-- PS Header -->
  <div class="blurb-header" *ngIf="blurbsList?.length > 0">
    <div class="item">
      <div class="row">
        <div class="col-md-11">
          <span (click)="sortblurbs('HEADER')">
            Header
            <i class="fa {{blurbQueryParam.field === 'HEADER' ? blurbQueryParam.order === 'ASC' ? 'fa-sort-amount-asc' : 'fa-sort-amount-desc' : 'fa-sort'}}"></i>
          </span>
        </div>
      </div>
    </div>
  </div>  

  <!-- Blurbs list -->
  <div class="blurbs-list" *ngIf="blurbsList?.length > 0">
    <div class="blurbs">
      <div *ngFor="let blurb of blurbsList; let i = index;">
        <div class="item cursorPointer">
          <div class="row">

            <!-- Blurbs Text -->
            <div class="column col-md-11" (click)="editBlurb(blurb)">
              <div>{{blurb.HEADER}}</div>
            </div>

            <!-- Blurbs options -->
            <div class="column end col-md-1 action">
              <div class="btn-group" dropdown>
                <button dropdownToggle type="button" class="btn btn-default btn-sm dropdown-toggle sub"
                  placement="bottom right">
                  <i class="fa fa-ellipsis-v"></i>
                </button>
  
                <div *dropdownMenu class="drop-menu">
                  <a class="drop-item" (click)="removeBlurb(blurb)">
                    <div class="item" style="display: contents;">Delete</div>
                  </a>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Blurbs Pagination -->
  <div [hidden]="totalItems < 10" class="pagination-wrapper pagination-cls">
    <pagination [boundaryLinks]="true" [totalItems]="totalItems" [itemsPerPage]="10" [maxSize]="5" (pageChanged)="pageChanged($event)"
                class="pagination-sm"></pagination>
  </div>  
</div>

<!-- Loader -->
<app-loader [loading]="loading"></app-loader>